enum ImageType {
  NotSet = 0,
  Basic = 1,
  Lifestyle = 2
}

export default ImageType;
